import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/privacy-policy")({
  head: () =>
    buildHead({
      title: "Privacy Policy | Precision Pavers & Pool Design",
      description:
        "Privacy policy for Precision Pavers & Pool Design. Learn how we collect, use, and protect your personal information when you request a free estimate or visit our website.",
      path: "/privacy-policy",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://precisionpaverspools.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Privacy Policy",
            item: "https://precisionpaverspools.com/privacy-policy",
          },
        ],
      },
    }),
  component: PrivacyPolicy,
});
